import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { Condition } from "@/modules/FormTemplate/models/Condition";
import { EditCondition } from "@/modules/FormTemplate/models/EditCondition";
import { Field } from "@/modules/FormTemplate/models/Field";
import { FieldConditional } from "@/modules/FormTemplate/models/FieldConditional";
import { RuleValue } from "@/modules/FormTemplate/models/RuleValue";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { PreventKey } from "@/shared/mixins/mixins";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);

@Component({
  name: "AddCondition",
  components: {
    DynamicSelect
  }
})
export default class AddCondition extends PreventKey {
  @Prop() private dialog!: boolean;
  @Prop() private fields!: Field[];
  @Prop() private formConditions!: Condition[];
  @Prop() private indexConditionalProp?: number;

  conditionName = "";
  listValue = false;
  ruleValues: RuleValue[] = [];
  conditionField: Field | undefined = {
    indicator: true,
    conversationTitle: "",
    editable: true,
    key: "",
    list: "",
    order: 0,
    required: true,
    schema: {
      title: "",
      type: ""
    },
    summary: true,
    summaryText: "",
    type: "",
    visible: true,
    visualElement: "",
    width: 12
  };
  conditionFields: Field[] = [];
  conditionFieldValue: RuleValue = {
    title: "",
    value: ""
  };
  conditionForm = false;
  fieldToCondition: Field[] = [];
  index = -1;

  SAVE = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;
  CONDITION_ADD_TITLE = FORM_TEMP_CONSTANTS.CONDITION_LABEL.ADD_TITLE;
  CONDITION_TITLE = FORM_TEMP_CONSTANTS.CONDITION_LABEL.TITLE;

  CONDITION_FIELD = FORM_TEMP_CONSTANTS.LABEL.FIELD;

  CONDITION_VALUE = FORM_TEMP_CONSTANTS.LABEL.VALUE;
  MIN_VALUE = FORM_TEMP_CONSTANTS.LABEL.MIN_VALUE;
  MAX_VALUE = FORM_TEMP_CONSTANTS.LABEL.MAX_VALUE;
  minValue = [FORM_VALIDATORS.MIN_VALUE];
  maxValue = [FORM_VALIDATORS.MAX_VALUE];

  sliderMaxValueMinimum = 1;
  CONDITION_MINIMUM_MIN_VALUE =
    FORM_TEMP_CONSTANTS.CONDITION_SLIDER_FIELD.MINIMUM_MIN_VALUE;

  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  textAreaClass = STYLE_CLASSES.TEXT_AREA;
  cardClass = STYLE_CLASSES.CARD;
  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  notBlankSpaces = [FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR];

  integerDecimalField = [FORM_VALIDATORS.INTEGER_AND_DECIMAL_NUMBER_FIELD];
  requiredArray = [FORM_VALIDATORS.REQUIRED_ARRAY];
  showConditionField = false;
  MAX_VALUE_LOWER_THAN_LOWER_VALUE =
    FORM_MESSAGES.MAX_VALUE_LOWER_THAN_LOWER_VALUE;
  datePickerMenu = false;
  fieldConditionModel = [{ name: "", id: "" }];
  valueFieldConditionModel = [{ name: "", id: "" }];
  checkFieldConditionModel: DynamicSelectData[] = [];

  dynamicConditionValueConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.CONDITION_VALUE,
    required: true
  };
  dynamicSelectConfigCheck: DynamicSelectConfig = {
    multiple: true,
    chips: true,
    default: [],
    listAll: [],
    filled: false,
    messageLabel: this.CONDITION_VALUE,
    persistenthint: true,
    required: true
  };

  get selectCheckField() {
    return this.checkFieldConditionModel.map(item => item.id);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set selectCheckField(value: any) {
    if (typeof value != "string") {
      value.map((it: string) => {
        const option = this.dynamicSelectConfigCheck.listAll.find(
          item => item.id === it
        );

        if (option != undefined) {
          this.checkFieldConditionModel = [
            {
              id: option?.id ? `${option?.id}` : "",
              name: option?.name ?? ""
            }
          ];
        }
      });
    } else {
      const option = this.dynamicSelectConfigCheck.listAll.find(
        item => item.id === value
      );
      if (option != undefined) {
        this.checkFieldConditionModel = [
          {
            id: option?.id ? `${option?.id}` : "",
            name: option?.name ?? ""
          }
        ];
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set selectValueConditionField(value: any) {
    const option = this.dynamicConditionValueConfig.listAll.find(
      item => item.id === value
    );
    if (option != undefined) {
      this.valueFieldConditionModel = [
        {
          id: `${option?.id}`,
          name: option?.name ?? ""
        }
      ];
    }
  }
  get selectValueConditionField() {
    return this.fieldConditionModel[0]?.id;
  }

  fillCondition(): FieldConditional | undefined {
    let newConditionField: FieldConditional | undefined;
    if (this.conditionField != undefined && this.conditionName !== "") {
      const numeric =
        this.conditionField.schema.type ===
        FORM_TEMP_CONSTANTS.FIELD_TYPE.NUMBER;
      const array =
        this.conditionField.visualElement ===
        FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX;

      newConditionField = {
        conditionName: this.conditionName,
        parentField: this.conditionField.key,
        isNumeric: numeric,
        isArray: array
      };

      if (
        numeric &&
        this.conditionFieldValue.minValue != undefined &&
        this.conditionFieldValue.maxValue != undefined
      ) {
        newConditionField.minValue = +this.conditionFieldValue.minValue;
        newConditionField.maxValue = +this.conditionFieldValue.maxValue;
      } else if (
        this.conditionFieldValue.value != undefined &&
        this.conditionFieldValue.value != ""
      ) {
        newConditionField.value = this.conditionFieldValue.value as string;
      } else if (
        this.conditionFieldValue.valueArray != undefined &&
        this.conditionFieldValue.valueArray.length > 0
      ) {
        const sorted = this.conditionFieldValue.valueArray.sort();
        newConditionField.valueArray = sorted;
      } else {
        newConditionField.value = false;
      }
      return newConditionField;
    } else {
      return undefined;
    }
  }

  addCondition() {
    let condition: Condition;
    const fieldCondition = this.fillCondition();

    if (fieldCondition != undefined) {
      condition = {
        condition: fieldCondition,
        fields: this.conditionFields
      };

      if (this.index === -1) {
        const data: EditCondition = { formCondition: condition };
        this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.ADD_NEW, data);
      } else {
        const data: EditCondition = {
          formCondition: condition,
          index: this.index
        };
        this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CONDITION.ADD_EDITED, data);
      }
    }
    this.clearConditionForms(this.fields, true);
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CLOSE_DIALOG);
  }

  @Watch("fields", { immediate: true, deep: true })
  @Watch("indexConditionalProp")
  @Watch("dialog", { immediate: true, deep: true })
  async associateConditionalField() {
    if (this.dialog) {
      if (
        this.indexConditionalProp !== undefined &&
        this.indexConditionalProp >= 0
      ) {
        const formCondition = this.formConditions[this.indexConditionalProp];
        const field = this.fields.find(
          field => field.key === formCondition.condition.parentField
        );

        if (field) {
          if (field.schema.oneOf != undefined) {
            this.dynamicConditionValueConfig.listAll = field.schema.oneOf.map(
              item => {
                return { id: `${item.const}`, name: item.title };
              }
            );
          }
          if (
            field.schema?.enum != undefined &&
            field.schema?.enum?.length > 0
          ) {
            this.dynamicSelectConfigCheck.listAll = field.schema.enum.map(
              item => {
                return { id: `${item}`, name: `${item}` };
              }
            );
          }
          if (field.schema?.items?.oneOf != undefined) {
            this.dynamicSelectConfigCheck.listAll = field.schema.items.oneOf.map(
              item => {
                return { id: `${item.const}`, name: item.title };
              }
            );
          }

          if (field.schema.items?.enum != undefined) {
            this.dynamicSelectConfigCheck.listAll = field.schema.items.enum.map(
              item => {
                return { id: `${item}`, name: item };
              }
            );
          }
          this.editGivenCondition(
            this.formConditions[this.indexConditionalProp],
            this.indexConditionalProp,
            field
          );
        }
      } else {
        this.clearConditionForms(this.fields, false);
      }
    }
  }

  editGivenCondition(condition: Condition, index: number, field: Field) {
    this.conditionFieldValue.value = "";
    this.showConditionField = false;
    this.index = index;
    this.conditionName = condition.condition.conditionName;
    this.conditionField = field;
    this.conditionFields = condition.fields;
    this.selectCheckField = condition.condition.valueArray ?? "";
    this.selectValueConditionField =
      condition.condition.value != undefined
        ? String(condition.condition.value)
        : "";
    this.conditionFieldValue = {
      title: "",
      value: condition.condition.value,
      valueArray: condition.condition.valueArray,
      minValue: condition.condition.minValue,
      maxValue: condition.condition.maxValue
    };

    this.fieldToCondition = this.fields;
    this.CONDITION_ADD_TITLE = FORM_TEMP_CONSTANTS.CONDITION_LABEL.EDIT_TITLE;
  }

  cancel() {
    this.clearConditionForms(this.fields, true);
    this.$emit(FORM_TEMP_CONSTANTS.EVENTS.CLOSE_DIALOG);
  }

  @Watch("conditionFieldValue", { deep: true })
  changeValues() {
    if (!isNaN(Number(this.conditionFieldValue.minValue))) {
      this.maxValue = [
        (v: any): any => {
          return (
            (v && v > Number(this.conditionFieldValue.minValue)) ||
            `${FORM_TEMP_CONSTANTS.MESSAGE.MAX_VAL_FIELD} ${Number(
              this.conditionFieldValue.minValue
            )}`
          );
        }
      ];
      this.sliderMaxValueMinimum =
        Number(this.conditionFieldValue.minValue) + 1;
    } else {
      this.sliderMaxValueMinimum = 1;
    }
    if (!isNaN(Number(this.conditionFieldValue.maxValue))) {
      this.minValue = [
        (v: any): any => {
          if (
            this.conditionFieldValue.maxValue &&
            v >= Number(this.conditionFieldValue.maxValue)
          ) {
            this.conditionFieldValue.maxValue =
              Number(this.conditionFieldValue.minValue) + 1;
          } else {
            if (
              this.conditionFieldValue.maxValue &&
              !isNaN(Number(this.conditionFieldValue.minValue))
            ) {
              this.conditionFieldValue.maxValue = Number(
                this.conditionFieldValue.maxValue
              );
            }
          }

          return (
            (v &&
              (v < Number(this.conditionFieldValue.maxValue) ||
                isNaN(Number(this.conditionFieldValue.maxValue)) ||
                Number(this.conditionFieldValue.maxValue) == 0)) ||
            `${FORM_TEMP_CONSTANTS.MESSAGE.MIN_VAL_FIELD} ${Number(
              this.conditionFieldValue.maxValue
            )}`
          );
        }
      ];
    }
  }
  @Watch("checkFieldConditionModel")
  checkFieldConditionChanged() {
    this.conditionFieldValue.valueArray = this.selectCheckField;
  }
  @Watch("valueFieldConditionModel")
  valueFieldConditionChanged() {
    this.conditionFieldValue.value = this.valueFieldConditionModel[0].id;
  }

  @Watch("conditionField")
  fieldChanged() {
    this.ruleValues = [];

    if (
      this.conditionField != undefined &&
      (this.conditionField.list != "" ||
        this.conditionField.visualElement ==
          FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX ||
        this.conditionField.visualElement ==
          FORM_TEMP_CONSTANTS.FIELD_TYPE.RADIO)
    ) {
      this.listValue = true;

      if (
        this.conditionField.schema["x-display"] !=
        FORM_TEMP_CONSTANTS.FIELD_TYPE.CHECKBOX
      ) {
        if (this.conditionField.schema.oneOf != undefined) {
          this.conditionField.schema.oneOf.forEach(object => {
            const ruleValue: RuleValue = {
              title: object.title,
              value: object.const
            };
            this.ruleValues.push(ruleValue);
          });
          this.dynamicConditionValueConfig.listAll = this.ruleValues.map(
            item => {
              return { id: `${item.value}`, name: item.title };
            }
          );
        } else if (this.conditionField.schema.enum !== undefined) {
          if (this.conditionField.schema.enum.length > 0) {
            this.conditionField.schema.enum.forEach(eachValue => {
              const ruleValue: RuleValue = {
                title: eachValue,
                value: eachValue
              };
              this.ruleValues.push(ruleValue);
            });
            this.dynamicSelectConfigCheck.listAll = this.ruleValues.map(
              item => {
                return { id: `${item.value}`, name: item.title };
              }
            );
          }
        }
      } else {
        if (this.conditionField.schema.items != undefined) {
          if (this.conditionField.schema.items.oneOf != undefined) {
            this.conditionField.schema.items.oneOf.forEach(object => {
              const ruleValue: RuleValue = {
                title: object.title,
                value: object.const
              };
              this.ruleValues.push(ruleValue);
              this.dynamicSelectConfigCheck.listAll = this.ruleValues.map(
                item => {
                  return { id: `${item.value}`, name: item.title };
                }
              );
            });
          } else if (this.conditionField.schema.items.enum != undefined) {
            this.conditionField.schema.items.enum.forEach(string => {
              const ruleValue: RuleValue = {
                title: string,
                value: string
              };
              this.ruleValues.push(ruleValue);
            });
            this.dynamicSelectConfigCheck.listAll = this.ruleValues.map(
              item => {
                return { id: `${item.value}`, name: item.title };
              }
            );
          }
        }
      }
    } else {
      this.listValue = false;
    }
  }

  clearConditionForms(fields: Field[], clear: boolean) {
    this.fieldToCondition = [];
    fields.forEach(f => {
      if (!this.formConditions.find(fc => fc.condition.parentField === f.key))
        this.fieldToCondition.push(f);
    });
    this.conditionField = clear
      ? {
          indicator: true,
          conversationTitle: "",
          editable: true,
          key: "",
          list: "",
          order: 0,
          required: true,
          schema: {
            title: "",
            type: ""
          },
          summary: true,
          summaryText: "",
          type: "",
          visible: true,
          visualElement: "",
          width: 12
        }
      : fields[0];
    this.conditionName = "";
    this.conditionFieldValue = {
      title: "",
      value: ""
    };
    this.index = -1;
    this.conditionFields = [];
    this.fieldConditionModel = [{ name: "", id: "" }];
    this.valueFieldConditionModel = [{ name: "", id: "" }];
    this.CONDITION_ADD_TITLE = FORM_TEMP_CONSTANTS.CONDITION_LABEL.ADD_TITLE;
    (this.$refs.form as Vue & {
      resetValidation: () => void;
    }).resetValidation();
  }

  @Watch("conditionFieldValue.maxValue")
  @Watch("conditionFieldValue.minValue")
  @Watch("conditionName")
  handleConditionFieldValue() {
    if (
      this.conditionField?.schema.type === "number" &&
      this.conditionFieldValue.maxValue &&
      this.conditionFieldValue.minValue
    ) {
      setTimeout(() => {
        this.conditionForm =
          (Number(this.conditionFieldValue.maxValue) || 0) >
            (Number(this.conditionFieldValue.minValue) || 0) &&
          this.conditionName.length > 0;
      }, 100);
    }
  }

  inputFieldIsDatePicker() {
    return (
      this.conditionField!.schema.type ==
        FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING &&
      this.conditionField!.schema.format == FORM_TEMP_CONSTANTS.FIELD_TYPE.DATE
    );
  }

  isStringField() {
    return (
      !this.listValue &&
      !(
        this.conditionField!.schema.type ==
        FORM_TEMP_CONSTANTS.FIELD_TYPE.NUMBER
      ) &&
      !(
        this.conditionField!.schema.format ==
        FORM_TEMP_CONSTANTS.FIELD_TYPE.DATE
      ) &&
      !(
        this.conditionField!.schema.type ==
        FORM_TEMP_CONSTANTS.FIELD_TYPE.BOOLEAN
      )
    );
  }
}
